module.exports = __webpack_public_path__ + "img/line (2).b465a076.png";